import React, { useEffect, useState } from "react"
import { useStore } from "../teafuljs/store"
import CheckCircle from "@material-ui/icons/CheckCircle"
import CheckCircleOutlined from "@material-ui/icons/CheckCircleOutlined"
import Brightness1Outlined from "@material-ui/icons/Brightness1Outlined"
import { makeStyles } from "@material-ui/core/styles"
import { checkReadMark } from "../scripts/checkReadMark"

const useStyles = makeStyles(theme => ({
  checkmarkdiv: {
    position: "relative",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    // margin: "20px auto",
  },
  checkmark: {
    width: "100%",
    height: "100%",
  },
}))

export default function ({ language, version, id, empty, disable }) {
  const classes = useStyles()
  const [readPlan, setReadPlan, resetReadPlan] = useStore.readPlan()
  const [readPlanID, setReadPlanID, resetReadPlanID] = useStore.readPlanID()
  const rpKey = readPlan
    ? readPlan[`readingPlan-${language}-${version}-${id}`]
    : null
  const [read, updateRead] = useState(rpKey)

  const EmptyCheckMark = ({ empty }) => {
    if (empty) {
      return (
        <Brightness1Outlined
          className={classes.checkmark}
          color="secondary"
          onClick={
            disable
              ? () => {}
              : () =>
                  checkReadMark(
                    read,
                    updateRead,
                    readPlan,
                    setReadPlan,
                    readPlanID,
                    setReadPlanID,
                    language,
                    version,
                    id
                  )
          }
        />
      )
    } else {
      return (
        <CheckCircleOutlined
          className={classes.checkmark}
          color="secondary"
          onClick={
            disable
              ? () => {}
              : () =>
                  checkReadMark(
                    read,
                    updateRead,
                    readPlan,
                    setReadPlan,
                    readPlanID,
                    setReadPlanID,
                    language,
                    version,
                    id
                  )
          }
        />
      )
    }
  }

  return (
    <div className={classes.checkmarkdiv}>
      {!readPlan ? null : readPlan[
          `readingPlan-${language}-${version}-${id}`
      ] ? (
        <CheckCircle
          className={classes.checkmark}
          color="secondary"
          onClick={disable ? () => { } : () =>
            checkReadMark(
              read,
              updateRead,
              readPlan,
              setReadPlan,
              readPlanID,
              setReadPlanID,
              language,
              version,
              id
            )
          }
        />
      ) : (
        <EmptyCheckMark empty={empty} />
      )}
    </div>
  )
}